import { useParams } from "@tanstack/react-router";
import { Flex } from "antd";

import { SubEntityLayout } from "#layouts";

import styles from "#modules/patient/Patient.module.scss";
import { pbmPortalPatientSubNavItems } from "#modules/patient/patientSubNavItems";

export const PbmPortalPatientDetail = () => {
	const { patientID } = useParams({ strict: false });

	return (
		<Flex vertical flex={1} className={styles.detail}>
			<SubEntityLayout
				parentScope={`pbm-portal-patient-${patientID}`}
				basePath={`/pbm-portal/patient/${patientID}`}
				subEntities={pbmPortalPatientSubNavItems}
			/>
		</Flex>
	);
};
